export default __webpack_public_path__ + "static/media/English.4113b9ea.svg";